module.exports = __webpack_public_path__ + "static/media/sell_take_order_make_4.17c105fd.jpg";